/* eslint-disable react/prop-types */ // TODO: add props
import { useEffect, useState } from 'react';
import { Button } from 'edrolo-style-guide';
import WistiaUtils from 'edrolo/utils/WistiaUtils';
import QuestionSolution from '../../../QuestionSolution';
import GrokSelfReflection from '../../../GrokSelfReflection';
import DragAndDropArea from 'core/components/DragAndDropArea';
import cx from 'classnames';
import s from './styles.scss';
import {
  getDraggableAnnotations,
  getDropzoneAnnotations,
} from 'admin/domains/examQuestion/components/Question/dragAndDropAnnotationFormHooks';

export const DragAndDropQuestion = ({
  question,
  response,
  onSubmit,
  onSubmitGrok,
  grokkingItemIsSaving,
  onSubmitTeacherAnswer,
  isQuestionReview = false,
  isPrint,
}) => {
  // TODO: convert this comment into propTypes (object has dynamic keys)
  // fieldResponseMap (dndMap) is a map of inputFieldId integers-as-strings to optionId integers
  const [fieldResponseMap, setFieldResponseMap] = useState({});

  const fieldResponsesToSubmit = Object.entries(fieldResponseMap)
    .filter(([_, selectedOptionId]) => !!selectedOptionId)
    .map(([fieldId, selectedOptionId]) => ({
      fieldId,
      selectedOptionId,
    }));

  const hasUnsubmittedResponse = !!fieldResponsesToSubmit.length;

  const handleDraggableRelocated = (draggableId, dropzoneId) => {
    setFieldResponseMap((prevFieldResponseMap) => ({
      ...prevFieldResponseMap,
      [draggableId]: dropzoneId,
    }));
  };

  const draggableAnnotations = getDraggableAnnotations(question);
  const dropzoneAnnotations = getDropzoneAnnotations(question);

  useEffect(() => {
    const dndMap = response
      ?.get('field_responses')
      ?.map((r) => ({
        fieldId: r.get('field_id'),
        optionId: r.get('selected_option_id'),
      }))
      ?.toJS()
      ?.reduce((acc, item) => ({ ...acc, [item.fieldId]: item.optionId }), {});

    if (dndMap) {
      setFieldResponseMap(dndMap);
    }
  }, [response, setFieldResponseMap]);

  const dndCorrectnessMap =
    response
      ?.get('field_responses')
      ?.map((r) => ({
        fieldId: r.get('field_id'),
        isCorrect: r.get('is_correct'),
      }))
      ?.toJS()
      ?.reduce(
        (acc, item) => ({ ...acc, [item.fieldId]: item.isCorrect }),
        {}
      ) || {};

  return (
    <>
      <div className={s.wrapper}>
        <div className={s.dragAndDropQuestion}>
          <div className={s.dndArea}>
            <DragAndDropArea
              draggableAnnotations={draggableAnnotations}
              dropzoneAnnotations={dropzoneAnnotations}
              imageUrl={question.get('image_url')}
              draggableToContainingDropzoneMap={fieldResponseMap}
              onDraggableRelocated={handleDraggableRelocated}
              dndCorrectnessMap={dndCorrectnessMap}
              isPrint={isPrint}
            />
          </div>
        </div>

        {!!response && !isQuestionReview && (
          <span
            className={cx(s.checkmark, {
              [s.incorrect]: !response?.get('is_correct', false),
            })}
          />
        )}
      </div>

      {!response && !isQuestionReview && (
        <Button
          onClick={() =>
            onSubmitTeacherAnswer
              ? onSubmitTeacherAnswer()
              : onSubmit({ fieldResponses: fieldResponsesToSubmit })
          }
          disabled={!hasUnsubmittedResponse}
        >
          {onSubmitTeacherAnswer ? 'View answer' : 'Save & continue'}
        </Button>
      )}

      {!!response && !isQuestionReview && (
        <>
          <QuestionSolution
            headingText="Solution"
            questionId={question.get('id')}
            explanation={response.getIn(['solution', 'explanation'])}
            videoHash={response.getIn([
              'solution',
              'video',
              'wistia_hashed_id',
            ])}
            videoThumbnailUrl={WistiaUtils.getThumbnail(
              response.getIn(['solution', 'video'])
            )}
          />
          {!isPrint && (
            <GrokSelfReflection
              value={response.get('grokked')}
              onChange={onSubmitGrok}
              isSaving={grokkingItemIsSaving}
            />
          )}
        </>
      )}
    </>
  );
};
